
define('ldsh!modules/page_generator/templates/external_confirmation', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<!DOCTYPE html>\n<html>\n<head>\n\t<!-- default styles/scripts -->\n \t<link rel="stylesheet" href="/app/styles/templates.css" />\n</head>\n<body>\n\t<div class="wrapper" style="margin: 0 auto; max-width: 450px">\n\t\t<p class="ed-hero js-external-description">\n\t\t\t' +
((__t = ( message )) == null ? '' : __t) +
'\n\t\t</p>\n\t\t<p class="ed-hero"><a href="' +
((__t = ( confirmationUrl )) == null ? '' : __t) +
'" target="_blank">' +
__e( confirmationUrl ) +
'</a></p>\n\t</div>\n</body>\n</html>';

}
return __p
};});

